<template>
  <BaseModal
    :showing="visible"
    @close="$emit('close')"
    size="max-w-6xl"
    @opened="onOpened"
  >
    <BaseCard title="Atur Metode Pembayaran" :with-style="false">
      <form action="" :class="me.office_type === 'pusat' ? 'grid grid-cols-2 gap-4' : 'space-y-4'" @submit.prevent="onSave">
        <BaseInput label="Jenis Metode Pembayaran" class="col-span-full" inset>
          <BaseSelect inset expand :options="[
            { key: 'bank', label: 'Bank', value: 'bank' },
            { key: 'qris', label: 'QRIS', value: 'qris' }
          ]" v-model="form.type" />
        </BaseInput>
        <BankSelectSearch :shadow="false" fullwidth inset label="Pencarian Bank" v-model="form.bank" />
        <BaseInput
          inset
          type="text"
          label="No Rekening"
          placeholder="ex: 321032131"
          v-model="form.accountNumber"
        />
        <BaseInput
          class="col-span-full"
          inset
          type="text"
          label="Nama Di Rekening"
          placeholder="ex: David"
          v-model="form.accountName"
        />
        <template v-if="me.office_type === 'pusat' && (form.type === 'bank' || form.type === 'qris')">
          <BaseInput
            inset
            type="text"
            label="No Account GL"
            placeholder="ex: 83012983201"
            v-model="form.noAccountGl"
          />
          <BaseInput
            inset
            type="text"
            label="Cost Center"
            placeholder="ex: 23109"
            v-model="form.costCenter"
          />
        </template>
        <div class="hidden" id="qris-scanner"></div>
        <base-input
          v-if="form.type === 'qris'"
          fullwidth
          :shadow="false"
          type="file"
          size="padding-md"
          inset
          label="Upload QRIS"
          accept="image/*"
          class="col-span-full"
          @change="onChangeImage"
        />

        <div class="col-span-full flex justify-end gap-2">
          <BaseButton :disabled="form.type === 'qris' && !form.qris">Simpan</BaseButton>
          <BaseButton color="white" type="button" @click="$emit('close')"
            >Kembali</BaseButton
          >
        </div>
      </form>
    </BaseCard>

    <Teleport to="body">
      <Loading v-if="loadingSave" />
    </Teleport>
  </BaseModal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { requestMixin } from '../../mixins/request/request';
import BaseModal from '../base/BaseModal.vue';
import Teleport from 'vue2-teleport';
import BankSelectSearch from './bank-select-search.vue';
import { Html5Qrcode } from 'html5-qrcode';
import qrisService from '../../services/qris.service';

export default {
  mixins: [requestMixin],
  components: { BaseModal, Teleport, BankSelectSearch },
  props: {
    visible: Boolean,
    data: Object,
  },
  emits: ['close', 'saved', 'created'],
  data() {
    return {
      loadingSave: false,
      form: {
        id: null,
        type: 'bank',
        bank: null,
        accountName: null,
        accountNumber: null,
        noAccountGl: null,
        costCenter: null,
        qris: null,
        image: null
      },
      qrCodeScanner: null
    };
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
    })
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    async onChangeImage(e) {
      if (!e.target.files.length) {
        this.form.image = null

        return
      }

      try {
        this.form.image = e.target.files[0]

        const res = await this.qrCodeScanner.scanFile(this.form.image, false)

        qrisService.validateQris(res)

        this.form.qris = res
      } catch (err) {
        this.form.qris = null

        this.createAlert({
          type: 'confirm',
          status: 'error',
          data: 'QRIS tidak valid',
          autoClose: false
        })
      }
    },
    async onOpened() {
      this.form.id = this.data.id ?? null;
      this.form.type = this.data.type ?? 'bank';
      this.form.bank = this.data.bank ?? null;
      this.form.accountName = this.data.accountName ?? null;
      this.form.accountNumber = this.data.accountNumber ?? null;
      this.form.noAccountGl = this.data.noAccountGl ?? null;
      this.form.costCenter = this.data.costCenter ?? null;
      this.form.image = null
      this.form.qris = this.data.qris ?? null;

      await this.$nextTick(() => {
        this.qrCodeScanner = new Html5Qrcode('qris-scanner')
      })
    },
    async onSave() {
      this.loadingSave = true;

      const [res, err] = await this.request(
        this.form.id
          ? `/api/v1/office-banks/${this.form.id}`
          : `/api/v1/office-banks`,
        {
          method: this.form.id ? 'patch' : 'post',
          data: {
            data: {
              type: 'office-banks',
              ...(this.form.id ? { id: this.form.id } : {}),
              attributes: {
                office_bank_type: this.form.type,
                account_name: this.form.accountName,
                account_number: this.form.accountNumber,
                no_account_gl: this.form.noAccountGl,
                cost_center: this.form.costCenter,
                ...(this.form.type === 'qris' ? { qris: this.form.qris } : {}),
                ...(this.form.id ? {} : { is_active: true }),
              },
              relationships: {
                bank: {
                  data: {
                    type: 'banks',
                    id: this.form.bank.id,
                  },
                },
                office: {
                  data: {
                    type: 'offices',
                    id: this.me.office_id,
                  },
                },
              },
            },
          },
        }
      );

      if (err) {
        this.createAlert({
          status: 'error',
          data: this.getRequestErrorMessage(err),
        });
      } else {
        this.createAlert({
          status: 'success',
          data: 'Data berhasil disimpan',
        });

        this.$emit('saved', res);
      }

      this.loadingSave = false;
    },
    async uploadImage(officeBankId) {
      const formData = new FormData();

      formData.append('image', this.form.image);
        
      await this.request(`/api/v1/office-banks/${officeBankId}/-actions/upload-image`, 
        {
          method: 'post',
          data: formData,
        }
      )
    }
  }
};
</script>
